import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';
const { createOutlet } = EventsApiService();

export const useCreateOutlet = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createOutlet(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Outlet has been updated successfully!!");
                } else {
                    message.success("Outlet has been created successfully!!");
                }
            },
        },
    );
};
